import { IDocumentReference, ICollectionReference } from '../database-cast/IDatabase';
import { DbLotteryFilterParam } from './db-lottery-filter';
import { DbListBase } from './db-list-base';
import { LotteryFilterParam } from '../../_shared/models/filter.model';


export class DbCustomerLotteryFiltersParams extends DbListBase<LotteryFilterParam> {
    // private _collection: ICollectionReference;
 
     constructor(collection: ICollectionReference) {
         super(collection);

     }
         public getFilterParam(id:string) {
         let params = new DbLotteryFilterParam(id,this._collection);
 
         return params;
     }
 
 }

 
// export class DbCustomerLotteryFiltersParams {

//     private _doc: IDocumentReference;

//     constructor(doc: IDocumentReference) {
//         this._doc = doc;
//     }


//     public updateRange(params: any[]): Promise<any> {

 

//         let promise: Promise<any[]> = new Promise((resolve, reject) => 
//             {
//                 let count = params.length;

//                 params.forEach(param => { 
                    
//                     delete param.updated;
                    
//                     this._doc.collection("values").doc(param.id)
//                         .set(Object.assign({}, param))
//                         .then(() => {
//                             count--;

//                             if (count <= 0) {
//                                 resolve(params);
//                             }
//                         })
//                         .catch(error => {
//                             reject(error);
//                         })
//                 });

//             });


//             return promise;

//     }

//    public  selectAll(): Promise<any> {
//         let promise: Promise<any[]> = new Promise((resolve, reject) => {

//            this._doc.collection("values")
//                 .limit(30)
//                 .get()
//                 .then((querySnapshot: any) => {

//                     let params: Array<any> = [];
//                     querySnapshot.forEach(doc => {
//                         let param = doc.data();

//                         params.push(param);
//                     });


//                     resolve(params);

//                 })
//                 .catch(error => {
//                     reject(error);
//                 });


//         });


//         return promise;
//       }

      
// }